module.exports = __webpack_public_path__ + "img/10551380_L.d2ef4347.png";